import { Box, Typography } from '@mui/material';
import { messages } from 'i18n/localization';
import { useIntl } from 'react-intl';
import { ReactComponent as Tree } from '../../../../../../assets/tree-icon.svg';
import { cutDecimalPlaces } from 'util/NumberUtil';

// Taken from https://www.co2online.de/service/klima-orakel/beitrag/wie-viele-baeume-braucht-es-um-eine-tonne-co2-zu-binden-10658/
const YearlyCarbonStorageOfBeechTree = 12.5;

function determineTimePeriod(co2Equivalents: number) {
    const numberOfYears = co2Equivalents / YearlyCarbonStorageOfBeechTree;
    if (numberOfYears > 1) return { value: cutDecimalPlaces(numberOfYears, 1), unit: 'years' };
    return { value: cutDecimalPlaces(numberOfYears * 12, 1), unit: 'months' };
}

export function Comparison(props: { co2Equivalents: number }) {
    const intl = useIntl();
    const { value: timePeriod, unit: unitOfTimePeriod } = determineTimePeriod(props.co2Equivalents);

    return (
        <Box>
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 2 }}>
                <Tree />
                <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                    <Typography sx={{ fontSize: [28, 36], color: 'primary.main', fontWeight: 'bold' }}>
                        1 {intl.formatMessage(messages.mnestix.productCarbonFootprint.beech)}
                    </Typography>
                    <Typography sx={{ fontSize: [28, 36], color: 'primary.main', fontWeight: 'bold' }}>
                        {timePeriod} {intl.formatMessage(messages.mnestix.productCarbonFootprint[unitOfTimePeriod])}
                    </Typography>
                </Box>
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', marginTop: 2 }}>
                <Typography variant="caption">
                    {intl.formatMessage(messages.mnestix.productCarbonFootprint.comparisonAssumption)}
                </Typography>
            </Box>
        </Box>
    );
}
